const DEFAULT_ORGANIZATION_NAME = 'Omya';

export const isOmya = (organization: string) => {
  if (!organization) {
    return false;
  }

  return organization.toLowerCase() === DEFAULT_ORGANIZATION_NAME.toLowerCase();
};
